export const convertImageToWebp = (image, file) => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const userImage = new Image();
    userImage.src = image;

    //перемальовуємо картинку в canvas
    userImage.onload = function () {
      canvas.width = userImage.width;
      canvas.height = userImage.height;
      ctx.drawImage(userImage, 0, 0);

      const webpImage = canvas.toDataURL('image/webp', 1);

      //перетворюємо dataURL на звичайний файл
      const base64 = webpImage.split(',')[1];
      const decodedData = window.atob(base64);
      const mimeString = webpImage.split(',')[0].split(':')[1].split(';')[0];
      const arrayBuffer = new ArrayBuffer(decodedData.length);
      const uint8Array = new Uint8Array(arrayBuffer);

      for (let i = 0; i < decodedData.length; i++) {
        uint8Array[i] = decodedData.charCodeAt(i);
      }

      const blob = new Blob([uint8Array], { type: mimeString });
      const webpFile = new File([blob], file.name, { type: mimeString });
      resolve(webpFile);
    };
  });
};
